import useCreatePromotions from './useCreatePromotions';

export default useCreatePromotions;
